import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { blue, red } from "@mui/material/colors";
import { SxProps, useTheme } from "@mui/material/styles";

import { capitalize } from "lodash";

import { Ear } from "../pure-tone-audiogram.type";
import { getPureToneAverage } from "./utils/get-pure-tone-average.utils";

interface PureToneAverageProps {
  airConductionValues: (string | number | null)[];
  ear: Ear;
  sx?: SxProps;
}
export default function PureToneAverage({
  airConductionValues,
  ear,
  sx = {}
}: PureToneAverageProps) {
  const { palette } = useTheme();
  const color = ear === "left" ? blue[900] : red[900];

  const acPureToneAverage = getPureToneAverage(airConductionValues);
  if (acPureToneAverage === null) return null;

  return (
    <Stack
      data-testid={`${ear}-pure-tone-average`}
      justifyContent="center"
      alignItems="center"
      sx={{ mb: 1, ...sx }}
    >
      <Box
        textAlign="center"
        sx={{ border: `1px solid ${palette.divider}`, p: 0.75, mr: 1.0 }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            textTransform: "uppercase",
            color,
            mb: 1
          }}
        >
          {capitalize(ear ?? "")}&nbsp;EAR&nbsp;PTA
          <br />
          (0.5,&nbsp;1k,&nbsp;2k&nbsp;Hz)
        </Typography>
        <Typography sx={{ color }}>{acPureToneAverage}</Typography>
      </Box>
    </Stack>
  );
}
